var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tools" }, [
    _c(
      "p",
      { attrs: { title: "标题" } },
      [
        _c(
          "el-select",
          {
            staticStyle: { width: "90px" },
            attrs: { size: "mini" },
            on: {
              change: function($event) {
                return _vm.styleChange(_vm.format.header, "header")
              }
            },
            model: {
              value: _vm.format.header,
              callback: function($$v) {
                _vm.$set(_vm.format, "header", $$v)
              },
              expression: "format.header"
            }
          },
          _vm._l(_vm.headerStyleList, function(header) {
            return _c("el-option", {
              key: header.value,
              attrs: { label: header.label, value: header.value }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      { attrs: { title: "字体大小" } },
      [
        _c(
          "el-select",
          {
            staticStyle: { width: "90px" },
            attrs: { size: "mini" },
            on: {
              change: function($event) {
                return _vm.styleChange(_vm.format.size, "size")
              }
            },
            model: {
              value: _vm.format.size,
              callback: function($$v) {
                _vm.$set(_vm.format, "size", $$v)
              },
              expression: "format.size"
            }
          },
          _vm._l(_vm.fontSizeList, function(styleItem) {
            return _c("el-option", {
              key: styleItem,
              attrs: { label: styleItem, value: styleItem }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      { attrs: { title: "行高" } },
      [
        _vm.format.lineHeight
          ? _c("img", {
              attrs: {
                src: require("../../../static/images/newCourseImages/hg@2x.png")
              },
              on: {
                click: function($event) {
                  return _vm.addStyle("lineHeight", _vm.format.lineHeight)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticStyle: { width: "80px" },
            attrs: { size: "mini" },
            on: {
              change: function($event) {
                return _vm.styleChange(_vm.format.lineHeight, "lineHeight")
              }
            },
            model: {
              value: _vm.format.lineHeight,
              callback: function($$v) {
                _vm.$set(_vm.format, "lineHeight", $$v)
              },
              expression: "format.lineHeight"
            }
          },
          _vm._l(_vm.lineHeightList, function(styleItem) {
            return _c("el-option", {
              key: styleItem,
              attrs: { label: styleItem, value: styleItem }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      { attrs: { title: "字体颜色" } },
      [
        _c(
          "el-popover",
          {
            ref: "color",
            attrs: {
              placement: "bottom",
              width: "150",
              "popper-class": "colorTools_popper",
              trigger: "click"
            }
          },
          [
            _c(
              "ul",
              _vm._l(_vm.predefineColors, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors1, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors2, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors3, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors4, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors5, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("color", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "el-icon-edit",
              staticStyle: { cursor: "pointer" },
              style: { color: _vm.format.color },
              attrs: { slot: "reference", title: "字体色" },
              on: {
                click: function($event) {
                  return _vm.addColor("color", _vm.format.color)
                }
              },
              slot: "reference"
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          {
            ref: "background",
            attrs: {
              placement: "bottom",
              width: "150",
              "popper-class": "colorTools_popper",
              trigger: "click"
            }
          },
          [
            _c(
              "ul",
              _vm._l(_vm.predefineColors, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors1, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors2, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors3, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors4, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.predefineColors5, function(color) {
                return _c(
                  "li",
                  {
                    key: color,
                    staticClass: "color",
                    on: {
                      click: function($event) {
                        return _vm.addColor("background", color)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "100%" },
                      style: { background: color }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "backgroundColor",
              staticStyle: { cursor: "pointer" },
              style: { background: _vm.format.background },
              attrs: { slot: "reference", title: "背景色" },
              on: {
                click: function($event) {
                  return _vm.addColor("background", _vm.format.background)
                }
              },
              slot: "reference"
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { attrs: { title: "字体样式" } }, [
      _vm.format.bold
        ? _c("img", {
            attrs: {
              title: "加粗",
              src: require("../../../static/images/newCourseImages/jc-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("bold", false)
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "加粗",
              src: require("../../../static/images/newCourseImages/jc-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("bold", true)
              }
            }
          }),
      _vm._v(" "),
      _vm.format.italic
        ? _c("img", {
            attrs: {
              title: "斜体",
              src: require("../../../static/images/newCourseImages/qx-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("italic", false)
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "斜体",
              src: require("../../../static/images/newCourseImages/qx-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("italic", true)
              }
            }
          }),
      _vm._v(" "),
      _vm.format.underline
        ? _c("img", {
            attrs: {
              title: "下划线",
              src: require("../../../static/images/newCourseImages/xhx-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("underline", false)
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "下划线",
              src: require("../../../static/images/newCourseImages/xhx-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("underline", true)
              }
            }
          }),
      _vm._v(" "),
      _vm.format.strike
        ? _c("img", {
            attrs: {
              title: "穿插线",
              src: require("../../../static/images/newCourseImages/scx-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("strike", false)
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "穿插线",
              src: require("../../../static/images/newCourseImages/scx-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("strike", true)
              }
            }
          })
    ]),
    _vm._v(" "),
    _c("p", { attrs: { title: "代码块" } }, [
      _vm.format["code-block"]
        ? _c(
            "svg",
            {
              staticClass: "icon svg-icon isactive",
              staticStyle: {
                width: "16px",
                height: "16px",
                "vertical-align": "-0.15em",
                margin: "0 6px"
              },
              attrs: { "aria-hidden": "true" },
              on: {
                click: function($event) {
                  return _vm.addStyle("code-block", false)
                }
              }
            },
            [_c("use", { attrs: { "xlink:href": "#icon-daima" } })]
          )
        : _c(
            "svg",
            {
              staticClass: "icon svg-icon",
              staticStyle: {
                width: "16px",
                height: "16px",
                "vertical-align": "-0.15em",
                margin: "0 6px"
              },
              attrs: { "aria-hidden": "true", title: "代码块" },
              on: {
                click: function($event) {
                  return _vm.addStyle("code-block", true)
                }
              }
            },
            [_c("use", { attrs: { "xlink:href": "#icon-daima" } })]
          ),
      _vm._v(" "),
      _vm.format.link
        ? _c("img", {
            attrs: {
              title: "链接",
              src: require("../../../static/images/newCourseImages/link-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("link", false)
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "链接",
              src: require("../../../static/images/newCourseImages/link@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("link", true)
              }
            }
          }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          title: "插入图片",
          src: require("../../../static/images/newCourseImages/tp@2x.png")
        },
        on: {
          click: function($event) {
            return _vm.addStyle("image", true)
          }
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "el-icon-discount",
        attrs: { title: "清除样式" },
        on: {
          click: function($event) {
            return _vm.addStyle("clean", true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("p", { attrs: { title: "对齐方式" } }, [
      _vm.format.align === "justify"
        ? _c("img", {
            attrs: {
              title: "左对齐",
              src: require("../../../static/images/newCourseImages/zdq-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "justify")
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "左对齐",
              src: require("../../../static/images/newCourseImages/zdq-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "justify")
              }
            }
          }),
      _vm._v(" "),
      _vm.format.align === "center"
        ? _c("img", {
            attrs: {
              title: "居中对齐",
              src: require("../../../static/images/newCourseImages/jz-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "center")
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "居中对齐",
              src: require("../../../static/images/newCourseImages/jz-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "center")
              }
            }
          }),
      _vm._v(" "),
      _vm.format.align === "right"
        ? _c("img", {
            attrs: {
              title: "右对齐",
              src: require("../../../static/images/newCourseImages/y-2@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "right")
              }
            }
          })
        : _c("img", {
            attrs: {
              title: "右对齐",
              src: require("../../../static/images/newCourseImages/y-1@2x.png")
            },
            on: {
              click: function($event) {
                return _vm.addStyle("align", "right")
              }
            }
          })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0056acd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0056acd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zl-editor/tools.vue
// module id = null
// module chunks = 